import { Component, OnInit } from '@angular/core';
import { TcPage, IPageState } from '@tc/core';
import { EntitiesEnum } from 'src/generated/EntitiesEnum';
import { ToggleFilterModel } from 'src/app/modules/core/models/toggle-filter.model';
import { HolidayDbStatus } from 'src/app/modules/core/enums/holiday-db-status.enum';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-holidays-page',
  templateUrl: './holidays-page.component.html',
  styleUrls: ['./holidays-page.component.scss']
})
export class HolidaysPageComponent extends TcPage implements OnInit {

  constructor(
    store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'holidays-page.title'
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }

}
